import * as React from "react"
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {NavigationBar, Layout} from "./layout"
import mahaStupa from "./assets/mahaStupa.png"
import vesak from "./assets/vesak_orig.jpg"
import guanyinBirthday from "./assets/guanyin-birthday.png"
import SummerChanQi from "./assets/chanqi-thumb-summer-2025.jpg";
import SummerFoQi from "./assets/foqi-thumb-summer-2025.jpg";
import Table from 'react-bootstrap/Table';
import GuanYinEnlightenment from "./assets/guanyin-enlightenment-letter.png";
import GuanYinLeftHome from "./assets/guanyinlh-letter.png";
import Ullambana from "./assets/ullambana.png";
import MedicineMasterBuddhaBirthday from "./assets/medicine-master-buddha-letter.png";
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import { Typography, Box, Stack } from "@mui/material";
import { useLocation, Link } from 'react-router-dom';
import { useEffect } from 'react';


export const events=[
{
    "title": "大悲懺",
    "dateBegin": "2025-12-21 08:00",
    "dateEnd": "2025-12-21 09:40",
    "poster": "gcr-dec-21_orig.jpg",
    "thumbnail": "gcr-dec-21_orig.jpg",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 12月21日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "佛七",
    "dateBegin": "2025-12-27 13:00",
    "dateEnd": "2026-01-03 11:00",
    "poster": "summer-foqi-2025_orig.png",
    "thumbnail": "foqi-thumb-summer-2025.jpg",
    "html": <>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 12月27日星期六-1月3日（2026年）星期六<br/>
      <b>地點：</b>
        <Link to="/location" >
          溈山寺，金林寺，法藏寺
        </Link><br/>
    </Typography>
    <br/><Link to="/foqi" >
      <div style={{display: "flex", justifyContent: "center"}}>
        <Button style={{ background: "#282c34", color: "white",  }}>了解更多</Button>
      </div>
    </Link></>
},
{
    "title": "阿彌陀佛聖誕",
    "dateBegin": "2025-12-31 08:00",
    "dateEnd": "2025-12-31 09:40",
    "poster": "amitabha-buddha-s-birthday-6_orig.jpg",
    "thumbnail": "amitabha-buddha-s-birthday-6_orig.jpg",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 1月4日（2026年）星期日
      <br/>
      <b>時間：</b> 早上8點
      <br/>
    </Typography></>
},{
    "title": "禪七",
    "dateBegin": "2026-01-03 21:00",
    "dateEnd": "2026-02-07 11:00",
    "poster": "chanqi2026.png",
    "thumbnail": "chanqi2026.jpg",
    "html": <>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 1月3日星期六-2月7日星期六<br/>
      <b>地點：</b>
        <Link to="/location" >
          法藏寺，潙山寺，金林寺，
        </Link><br/>
    </Typography>
    <br/><Link to="/chanqi" >
      <div style={{display: "flex", justifyContent: "center"}}>
        <Button style={{ background: "#282c34", color: "white",  }}>了解更多</Button>
      </div>
    </Link></>
},

{
    "title": "大悲懺",
    "dateBegin": "2026-01-25 08:00",
    "dateEnd": "2026-01-25 09:40",
    "poster": "gcr-2026-jan-25.png",
    "thumbnail": "gcr-2026-jan-25.png",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 1月25日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >潙山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "彌勒佛聖誕",
    "dateBegin": "2026-02-15 08:00",
    "dateEnd": "2026-02-15 09:40",
    "poster": "maitreya-birthday-2026_orig.png",
    "thumbnail": "maitreya-birthday-2026_orig.png",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 2月15日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >法藏寺,溈山寺,金林寺</Link><br/>
    </Typography></>
},

{
    "title": "萬佛舍利展",
    "dateBegin": "2026-02-17 10:00",
    "dateEnd": "2026-02-22 19:00",
"poster": "2026-relics-finalflyer-wei_orig.png",
"thumbnail": "2026-relics-finalflyer-wei_orig.png",
"html": <><Typography variant="body1" style={{textAlign:"center"}}>
<b>日期：</b> 2月17日星期二-2月22日星期日<br/>
      <b>地點：</b>
        <Link to="/location" >
          法藏寺，潙山寺
        </Link><br/>

</Typography></>
},
{
    "title": "大悲懺",
    "dateBegin": "2026-03-29 08:00",
    "dateEnd": "2026-03-29 09:40",
    "poster": "gcr-2026-mar-29.png",
    "thumbnail": "gcr-2026-mar-29.png",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 3月29日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >潙山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "大悲懺",
    "dateBegin": "2026-04-26 08:00",
    "dateEnd": "2026-04-26 09:40",
    "poster": "gcr-2026-apr-26.png",
    "thumbnail": "gcr-2026-apr-26.png",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 4月26日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >潙山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "藥師佛寶懺",
    "dateBegin": "2026-03-15 08:00",
    "dateEnd": "2026-03-15 16:00",
    "poster": "mmbr_apr.png",
    "thumbnail": "mmbr_apr.png",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}>8am - 9:40 am<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_-_roll_1.pdf">Click here for Roll 1</a><br/>9:40 - Dharma Talk<br/>11 - Vegetarian Lunch<br/>12:30 - 1:50pm<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_roll_2.pdf">Click here for Roll 2</a><br/>2 - 3:40pm<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_roll_3.pdf">Click here for Roll 3</a><br/>​Location:<br/><Link to="/location" >
潙山寺 洛杉磯-Rosemead<br/>
法藏寺 舊金山</Link></Typography><br/></>
},
{
    "title": "大悲懺",
    "dateBegin": "2026-05-24 08:00",
    "dateEnd": "2026-05-24 09:40",
    "poster": "gcr-2026-may-24.png",
    "thumbnail": "gcr-2026-may-24.png",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 5月24日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >潙山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "大悲懺",
    "dateBegin": "2026-06-08 08:00",
    "dateEnd": "2026-06-08 09:40",
    "poster": "gcr-june-8_orig.jpg",
    "thumbnail": "gcr-june-8_orig.jpg",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 6月8日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "觀音七",
    "dateBegin": "2026-06-06 13:00",
    "dateEnd": "2026-06-13 11:00",
    "poster": "2026-guan-yin-qi.png",
    "thumbnail": "2026-guan-yin-qi.png",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 6月6日星期日 下午13:00-6月13日 早上11:00<br/>
      <b>地點：</b><Link to="/location" >法藏寺，潙山寺，金林寺</Link><br/>
    </Typography></>
},
{
    "title": "浴佛節",
    "dateBegin": "2026-05-31 08:00",
    "dateEnd": "2026-05-31 10:40",
    "poster": "vesak-2026.png",
    "thumbnail": "vesak-2026.png",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 5月31日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >潙山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},


{
    "title": "大悲懺",
    "dateBegin": "2026-06-28 08:00",
    "dateEnd": "2026-06-28 09:40",
    "poster": "gcr-2026-june-28.png",
    "thumbnail": "gcr-2026-june-28.png",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 6月28日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >潙山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},

{
    "title": "觀音菩薩成道日",
    "dateBegin": "2026-07-26 08:00",
    "dateEnd": "2026-07-26 09:40",
    "poster": "guanyin-enlightenment2026.png",
    "thumbnail": "guanyin-enlightenment2026.png",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}>
<b>日期：</b> 7月26日星期日<br/><b>時間：</b> 早上8:00<br/><b>地點：</b> <Link to="/location" >潙山寺，金林寺，法藏寺</Link><br/></Typography></>
},
{
    "title": "藥師佛誕辰",
    "dateBegin": "2026-11-16 08:00",
    "dateEnd": "2026-11-16 09:40",
    "poster": "medicine-master-buddha-letter-vertical-10_orig.jpg",
    "thumbnail": "medicine-master-buddha-letter-vertical-10_orig.jpg",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}>
<b>日期：</b> 11月16日星期日<br/><b>時間：</b> 早上8:00<br/><b>地點：</b> <Link to="/location" >溈山寺，金林寺，法藏寺</Link><br/></Typography></>
},
{
    "title": "觀音菩薩聖誕日",
    "dateBegin": "2026-04-05 08:00",
    "dateEnd": "2026-04-05 09:40",
    "poster": "guanyin-birthday-2026_orig.png",
    "thumbnail": "guanyinbirthday-thumbnail.png",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 3月24日星期日
      <br/>
      <b>時間：</b> 早上8點
      <br/>
    </Typography></>
},
{
    "title": "佛七",
    "dateBegin": "2026-06-13 13:00",
    "dateEnd": "2026-06-20 11:00",
    "poster": "foqi-letter-2026.png",
    "thumbnail": "foqi-letter-2026.png",
    "html": <>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 6月13日星期六-6月20日星期六<br/>
      <b>地點：</b>
        <Link to="/location" >
          法藏寺，潙山寺，金林寺
        </Link><br/>
    </Typography>
    <br/><Link to="/foqi" >
      <div style={{display: "flex", justifyContent: "center"}}>
        <Button style={{ background: "#282c34", color: "white",  }}>了解更多</Button>
      </div>
    </Link></>
},{
    "title": "禪七",
    "dateBegin": "2026-06-20 21:00",
    "dateEnd": "2026-07-04 11:00",
    "poster": "chanqi2026.png",
    "thumbnail": "chanqi2026.jpg",
    "html": <>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 6月20日星期六-7月4日星期六<br/>
      <b>地點：</b>
        <Link to="/location" >
          法藏寺，潙山寺，金林寺，
        </Link><br/>
    </Typography>
    <br/><Link to="/chanqi" >
      <div style={{display: "flex", justifyContent: "center"}}>
        <Button style={{ background: "#282c34", color: "white",  }}>了解更多</Button>
      </div>
    </Link></>
},
{
    "title": "藥師佛寶懺",
    "dateBegin": "2026-07-12 08:00",
    "dateEnd": "2026-07-12 16:00",
    "poster": "mmbr-july12.png",
    "thumbnail": "mmbr-july12.png",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}>8am - 9:40 am<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_-_roll_1.pdf">Click here for Roll 1</a><br/>9:40 - Dharma Talk<br/>11 - Vegetarian Lunch<br/>12:30 - 1:50pm<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_roll_2.pdf">Click here for Roll 2</a><br/>2 - 3:40pm<br/><a href="https://www.chanpureland.org/uploads/5/5/7/7/55776393/mmbr_roll_3.pdf">Click here for Roll 3</a><br/>​Location:<br/><Link to="/location" >
Wei Mountain Temple - Rosemead<br/>
Dharma Treasury Temple - San Francisco</Link></Typography><br/></>
},
{
    "title": "大悲懺",
    "dateBegin": "2026-07-19 08:00",
    "dateEnd": "2026-07-19 09:40",
    "poster": "gcr-2026-july-19.png",
    "thumbnail": "gcr-2026-july-19.png",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 7月19日星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >潙山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},


{
    "title": "大悲懺",
    "dateBegin": "2026-08-30 08:00",
    "dateEnd": "2026-08-30 09:40",
    "poster": "gcr-2026-aug-30.png",
    "thumbnail": "gcr-2026-aug-30.png",
    "html":<>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 8月30星期日 早上8:00<br/>
      <b>地點：</b><Link to="/location" >潙山寺，金林寺，法藏寺</Link><br/>
    </Typography></>
},
{
    "title": "盂蘭盆節",
    "dateBegin": "2026-08-23 08:00",
    "dateEnd": "2026-08-23 11:00",
    "poster": "ullambana-2026_orig.png",
    "thumbnail": "ullambana-2026_orig.png",
    "html": <><Typography variant="body1" style={{textAlign:"center"}}><b>日期：</b> 8月23日星期日 早上8:00<br/><b>地點：</b> <Link to="/location" >法藏寺，金林寺，潙山寺</Link><br/></Typography>
</>
},
{
    "title": "梁皇寶懺",
    "dateBegin": "2026-09-05 13:00",
    "dateEnd": "2026-09-11 11:00",
    "poster": "emperor-liang-repentance-flyer-official.png",
    "thumbnail": "emperor-liang-repentance-flyer-official.png",
    "html": <>
    <Typography variant="body1" style={{textAlign:"center"}}>
      <b>日期：</b> 9月5日星期六-9月11日星期六<br/>
      <b>地點：</b>
        <Link to="/location" >
          法藏寺，潙山寺，金林寺
        </Link><br/>
    </Typography>
    <br/><Link to="/foqi" >
      <div style={{display: "flex", justifyContent: "center"}}>
        <Button style={{ background: "#282c34", color: "white",  }}>了解更多</Button>
      </div>
    </Link></>
},





];

function UpcomingEvents () {
  const monthTextSize="0.85rem"
  const { hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  const getEventsInMonth=(k)=> {
    return events.filter(event => {
        const startDate = new Date(event.dateBegin);
        return startDate.getMonth() === k;
    });
}


  return (
    <><NavigationBar/>
      {/* Hero Image */}
<div style={{ display: "grid" }}>
      <img
        style={{
          gridArea: "1/1",
          // maxHeight: 600,
        }}
        layout="fullWidth"
        aspectRatio={3 / 1}
        alt=""
        src="/eventBanner.png"
        />
      <div
        style={{
          gridArea: "1/1",
          position: "relative",
          placeItems: "center",
          display: "grid",
        }}
      >
      </div>
    </div>
    {/* Main Content */}
  <Layout>
  <Table style={{tableLayout: "fixed"}}><tbody>
  <tr><td><Link to="/upcoming-events#jan"><Typography variant="body1" fontSize="0.8rem">一月</Typography></Link>
    </td><td/><td>
    <Link to="/upcoming-events#feb"><Typography variant="body1" fontSize="0.8rem">二月</Typography></Link>
    </td><td/><td><Link to="/upcoming-events#mar"><Typography variant="body1" fontSize="0.8rem">三月</Typography>  </Link></td><td/>
     <td><Link to="/upcoming-events#apr"><Typography variant="body1" fontSize="0.8rem">四月</Typography>   </Link>
     </td></tr>
       <tr><td>    <Link to="/upcoming-events#may"><Typography variant="body1" fontSize="0.8rem">五月</Typography>  </Link>

    </td><td/><td>
    <Link to="/upcoming-events#jun"><Typography variant="body1" fontSize="0.8rem">六月</Typography></Link>
    </td><td/><td>
    <Link to="/upcoming-events#jul"><Typography variant="body1" fontSize="0.8rem">七月</Typography> </Link>
    </td><td/>
     <td><Link to="/upcoming-events#aug"><Typography variant="body1" fontSize="0.8rem">八月</Typography>  </Link>
     </td></tr>
       <tr><td><Link to="/upcoming-events#sep"><Typography variant="body1" fontSize="0.8rem">九月</Typography>   </Link>

    </td><td/><td>
    <Link to="/upcoming-events#oct"><Typography variant="body1" fontSize="0.8rem">十月</Typography></Link>
    </td><td/><td>    <Link to="/upcoming-events#nov"><Typography variant="body1" fontSize="0.8rem">十一月</Typography> </Link>
    </td><td/>
     <td><Link to="/upcoming-events#dec"><Typography variant="body1" fontSize="0.8rem">十二月</Typography></Link>
     </td></tr>
     <tr id="jan"><td/><td colSpan={5}>
     {getEventsInMonth(0).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}
     </td><td/>
   </tr>

  <tr id="feb"><td/><td colSpan={5}>
  {getEventsInMonth(1).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

    </td><td/>
  </tr>
  <tr id="mar"><td></td><td colSpan={5}>
  {getEventsInMonth(2).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

</td><td></td>
  </tr>
  <tr id="apr"><td></td><td colSpan={5}>
  {getEventsInMonth(3).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

</td><td></td>
  </tr>
  <tr id="may"><td></td><td colSpan={5}>
  {getEventsInMonth(4).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}
   </td><td></td>
  </tr>
  <tr id="jun"><td></td><td colSpan={5}>
  {getEventsInMonth(5).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}
</td><td></td>
  </tr>
  <tr id="jul"><td></td><td colSpan={5}>
  {getEventsInMonth(6).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

    </td><td></td>
  </tr>
  <tr id="aug"><td></td><td colSpan={5}>
  {getEventsInMonth(7).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

  </td><td></td>
  </tr>
  <tr id="sep"><td></td><td colSpan={5}>
  {getEventsInMonth(8).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

  </td><td></td>
  </tr>
  <tr id="oct"><td></td><td colSpan={5}>
  {getEventsInMonth(9).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

</td><td></td>
  </tr>
  <tr id="nov"><td></td><td colSpan={5}>
  {getEventsInMonth(10).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

    </td><td></td>
  </tr>
  <tr id="dec"><td></td><td colSpan={5}>
  {getEventsInMonth(11).map(e=>(<><img src={`/${e.poster}`} quality={40} loading="lazy" /><br/>{e.html}</>))}

</td><td></td>
  </tr>
  </tbody></Table>
    </Layout></>);
}

export default UpcomingEvents
